import Vue from 'vue';
import schema from '../../droplet.schema';
const dropletSchema = schema();

export default Vue.component('audio-player-temp', {
  template: require('./template.html'),
  name: 'audio-player-temp',
  props: {
    title: {
      type: String,
      required: true,
      default: 'No Title',
    },
    file: {
      type: String,
      required: true,
      default: dropletSchema.audioFile,
    },
    id: {
      type: String,
      required: false,
      default: 'no-id',
    },
  },
  mounted() {
    $(document).ready(this.bindPlugin);
  },
  methods: {
    bindPlugin() {
      const ref = this.$refs.drzAudio;
      const $player = $(ref);
      $player.drzAudioPlayer();
    },
    unBindPlugin() {
      const ref = this.$refs.drzAudio;
      const $player = $(ref);
      if (ref) {
        $player.drzAudioPlayer.destroy($player);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-player/components/player/index.js